export const isExpiredData = (date: string) => {
  let isExpired = true;
  try {
    const exp = new Date(date).getTime();
    const now = new Date().getTime();
    isExpired = now > exp;
  } catch (error) {
    console.error(error);
  } finally {
    return isExpired;
  }
};
